import {Component, Input, OnInit} from '@angular/core';
import {ContentService} from "../../services/content.service";
import {LangService} from "../../services/lang.service";
import {ToastService} from "../../services/toast.service";
@Component({
    selector: 'app-block-rate-feedback',
    templateUrl: './block-rate-feedback.component.html',
    styleUrls: ['./block-rate-feedback.component.scss'],
    standalone: false
})
export class BlockRateFeedbackComponent implements OnInit {
    @Input() item: any;

    showFeedback = false;
    feedback: any = "";
    articleToken = "";
    finishedRating = false;
    constructor(
        private contentService: ContentService,
        public lang: LangService,
        public toastService: ToastService,
    ) {
    }

    ngOnInit() {
    }

    /**
     * Rate Article
     * @param isPositive
     */
    rateArticle(isPositive: number = 0) {
        this.contentService.rateArticle(this.item.id, isPositive)
            .then(response => {
                this.showFeedback = true;
                this.articleToken = response.data.article_token;
            })
            .catch((error: any) => {
                this.finishedRating = true;
                this.showFeedback = true;
            })

        this.toastService.toast(
            this.lang.data['feedback.confirmation'],
            'success',
        );
    }

    sendFeedback() {
        if (this.feedback.length === 0) return;

        this.contentService.feedbackArticle(this.articleToken, this.feedback)
            .then(
                () => {
                    this.finishedRating = true;
                    // this.toastService.toast(
                    //     this.lang.data['feedback.confirmation'],
                    //     'success',
                    // );
                })
            .catch(() => this.finishedRating = true)
    }


}
